import Service from "../Service";
const resource = "TasWeeklyProjectionCalendar/";

export default {
    save(cmp, requestID) {
        console.log("cmp", cmp);

        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    saveList(cmp, requestID) {
        return Service.post(resource + "saveList", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    ListProjection(parameters, requestID) {
        return Service.post(resource + "ListProjection", parameters, {
            params: { requestID: requestID },
        });
    },

    ListProjectionCalendar(parameters, requestID) {
        return Service.post(resource + "ListProjectionCalendar", parameters, {
            params: { requestID: requestID },
        });
    },

};